export const FEATURE_MODULE_ROUTE_DATA_KEY = 'featureModuleRouteData';
